// import { Injectable } from '@angular/core';
import { HttpClient, Observable, Injectable, NgxSpinnerService, ToastrService, HttpHeaders } from '../index';
import 'rxjs/add/observable/forkJoin';
import { resolve } from '../../../node_modules/@types/q';
declare var TCO: any;
import { GlobalConstant } from '../global/global.constant'
import { Subject } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable()

export class MainService {
    showSuccess(arg0: any) {
        throw new Error('Method not implemented.');
    }
    currencyLogo: any = 'AED';

    // baseUrl: String = 'https://backend.digixvsx.com/api/v1/';
    baseUrl: String = 'http://172.16.6.130:1808/api/v1/';
    // baseUrl: String = 'https://sportsweb-backend.mobiloitte.com/api/v1/'; //stagging
    //baseUrl: String = 'http://localhost:1808/api/v1/'; 
    // baseUrl:string='http://172.16.1.238:1808/api/v1/';
    //moin sir ip
    // baseUrl : string = "http://172.16.1.246:1808/api/v1/"

    loginRes: any = {};
    headerSub = new Subject();
    headerObs = this.headerSub.asObservable();
    mediaList: any = {};
    userDetails: any;
    userId: any;

    stripeKeyLive: any;
    constructor(private http: HttpClient, private spinner: NgxSpinnerService, private toastr: ToastrService) {
        this.baseUrl = environment.apiUrl;

        this.stripeKeyLive = environment.stripeKeyLive
        this.getLoginDetails()
    }
    getLoginDetails() {

        if (this.getStorage('userDetailYala') && this.getStorage('token')) {
            this.loginRes = JSON.parse(this.getStorage('userDetailYala'))
        } else {
            return localStorage.clear()
        }
    }
    getApi(url, isHeader): Observable<any> {
        let httpOptions = {};
        if (isHeader == 0) {
            return this.http.get((this.baseUrl + url));
        } else if (isHeader == 1) {
            //console.log('header 1');
            //console.log("ss"+JSON.parse(this.getStorage('userDetailYala'))._id);
            //console.log("ss"+JSON.parse(JSON.stringify(this.getStorage('token'))));
            //console.log('header 1');
            httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'userId': JSON.parse(this.getStorage('userDetailYala'))._id,
                    'token': JSON.parse(JSON.stringify(this.getStorage('token')))
                })
            };

            return this.http.get((this.baseUrl + url), httpOptions);
        }


    }
    //  End Get Api Call

    //  Post Api Call
    postApi(url, data, isHeader): Observable<any> {
        let httpOptions = {};
        if (isHeader == 0) {
            return this.http.post((this.baseUrl + url), data);
        } else if (isHeader == 1) {
            httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'userId': JSON.parse(this.getStorage('userDetailYala'))._id,
                    'token': JSON.parse(JSON.stringify(this.getStorage('token')))
                })
            };
            return this.http.post((this.baseUrl + url), data, httpOptions);
        } else if (isHeader == 2) {
            httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    //   'userId': this.loginRes.result._id,
                    //   'token': this.loginRes.token
                    'userId': JSON.parse(this.getStorage('userDetailYala'))._id,
                    'token': JSON.parse(JSON.stringify(this.getStorage('token')))
                })
            };
            return this.http.post((this.baseUrl + url), data, httpOptions);
        }
    }

    uploadImage(file): Observable<any> {
        let httpOptions = {};
        let data = new FormData()
        data.append('image', file)

        return this.http.post((this.baseUrl + 'users/uploadBinaryImage'), data);

    }
    postFormApi(url, data, isHeader): Observable<any> {
        let httpOptions = {};
        if (isHeader == 0) {
            return this.http.post((this.baseUrl + url), data);
        } else if (isHeader == 1) {
            httpOptions = {
                headers: new HttpHeaders({
                    'userId': JSON.parse(this.getStorage('userDetailYala'))._id,
                    'token': JSON.parse(JSON.stringify(this.getStorage('token')))
                })
            };
            return this.http.post((this.baseUrl + url), data, httpOptions);
        } else if (isHeader == 2) {
            httpOptions = {
                headers: new HttpHeaders({
                    'userId': JSON.parse(this.getStorage('userDetailYala'))._id,
                    'token': JSON.parse(JSON.stringify(this.getStorage('token')))
                })
            };
            return this.http.post((this.baseUrl + url), data, httpOptions);
        }
    }
    // End  Post Api Call
    // FormData Post Api Call
    // postApi1(url, data, isHeader): Observable<any> {
    // let httpOptions = {}
    // if(isHeader == 0)
    //     return this.http.post((this.baseUrl + url), data)
    // else if(isHeader == 1) {
    //     httpOptions = {
    //         headers: new HttpHeaders({ "userId": JSON.parse(this.getStorage('userDetailYala'))._id, "token": JSON.parse(JSON.stringify(this.getStorage('token')))  })
    //     }
    //     return this.http.post((this.baseUrl + url), data, httpOptions)
    // } else if(isHeader == 2) {
    //     httpOptions = {
    //         headers: new HttpHeaders({ "userId": this.loginRes.result._id, "token": this.loginRes.token  })
    //     }
    //     return this.http.post((this.baseUrl + url), data, httpOptions)
    // }

    // }
    // End FormData Post Api Call

    multipleGetApi(...urls) {
        let httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "application/json", "userId": JSON.parse(this.getStorage('userDetailYala'))._id, "token": JSON.parse(JSON.stringify(this.getStorage('token'))) })
        }
        let newArr = urls.map(i => this.http.get((this.baseUrl + i), httpOptions))
        console.log(newArr)
        return Observable.forkJoin(newArr)
    }
    multiplePostApi(...arr) {
        console.log(arr)
        let httpOptions = {
            headers: new HttpHeaders({ "Content-Type": "application/json", "userId": JSON.parse(this.getStorage('userDetailYala'))._id, "token": JSON.parse(JSON.stringify(this.getStorage('token'))) })
        }
        let newArr = arr.map(i => this.http.post((this.baseUrl + i.url), i.data, httpOptions))
        console.log(newArr)
        return Observable.forkJoin(newArr)
    }

    spinnerShow() {
        this.spinner.show();
    }

    spinnerHide() {
        this.spinner.hide()
    }
    toastrSucc(msg) {
        console.log('succ')
        this.toastr.success(msg)
    }

    toastrErr(msg) {
        console.log('error')
        this.toastr.error(msg)
    }
    //  Set LocalStorage Value
    setStorage(key, val) {
        localStorage.setItem(key, val)
    }
    //  End Set LocalStorage Value

    //  Get LocalStorage Value
    getStorage(key) {
        return localStorage.getItem(key)
    }
    //  End Get LocalStorage Value  //

    // Remove LocalStorage
    removeStorage(key) {
        if (localStorage.getItem(key) !== null) {
            localStorage.removeItem(key)
        }
    }

    fileChangeEvent(fileInput: any) {
        return new Promise((resolve, reject) => {
            if (fileInput.target.files && fileInput.target.files[0]) {
                let reader = new FileReader();
                // let self = this;
                reader.onload = (e: any) => {
                    resolve(e)
                    //   self.addFileData.file = e.target.result
                }
                reader.readAsDataURL(fileInput.target.files[0])
            }
        })

    }
    printFun(id): void {
        console.log('id =====>>>', id);
        let printContents, popupWin;
        printContents = document.getElementById(id).innerHTML;
        console.log('printContents ===>>>', printContents);
        popupWin = window.open('', '_blank', 'top=70px,left=0,height=100%,width=auto');
        console.log('popupWin ===>>>', popupWin);
        popupWin.document.open();
        popupWin.document.write(`
          <html>
            <head>
              <title>Print tab</title>
              <style>
              //........Customized style.......
              .table-block .table-bordered thead th{
                font-weight:normal;
                vertical-align: middle;
            }
            .table-head-bg {
              color: #fff;
              background-color: #1e8ea8;
          }
          .table-block .table-bordered thead th, .table-block .table-bordered tbody td {
            border: 1px solid #ddd;
        }
        .extra-large-table th, tr {
          text-align: center;
      }
              </style>
            </head>
        <body onload="window.print();window.close()">${printContents}</body>
          </html>`
        );
        popupWin.document.close();
    }


    headerSubChange(msg) {
        this.headerSub.next(msg)
    }


    //   pay(fo) {
    //     var self = this;
    //     TCO.loadPubKey('sandbox', function() {
    //       self.spinner.show()
    //       // Execute when Public Key is available
    //       console.log('initiate ')
    //       var tokenData = {
    //         sellerId: GlobalConstant.paymentCredential.sellerId,//901386003
    //         publishableKey: GlobalConstant.paymentCredential.publishableKey,//4769A4CA-5488-4585-B1DF-B8AB85753020
    //         ccNo: self.cardForm.value.card,//"4111111111111111"
    //         cvv: self.cardForm.value.cvv,
    //         expMonth: self.cardForm.value.expiryDate.split('-')[1],
    //         expYear: self.cardForm.value.expiryDate.split('-')[0]
    //       }
    //       console.log(tokenData)
    //       TCO.requestToken(succToken, errToken, tokenData)
    //       });​
    //       var succToken = function(data) {
    //         let newArr = self.addonArr.filter(x => x.checked).map(x => x.name)
    //         console.log('succ token=> '+ JSON.stringify(data))
    //         self.spinner.hide()
    //         let tokenData = Object.assign({}, { optionalSubsPrices: newArr, subscription: self.newPlan, autoRenewPlan: self.autoRenewPlan }, data)
    //         self.service.postApi(`users/paymentOrder`, tokenData, 1).subscribe(response => {
    //           if(response.responseCode == 200) {
    //             $('#paymentPlanChange').modal('hide')
    //             self.service.toastrSucc(response.responseMessage)
    //             // self.service.setStorage( 'userDetailYala', JSON.stringify({token: self.loginRes.token, role: self.loginRes.result.role[0], userType: self.loginRes.result.organizerType, _id: self.loginRes.result._id}) )
    //             // self.router.navigate(['/organizer/dataTeams'])
    //           }
    //         })
    //       }
    //       var errToken = function(err) {
    //         console.log('err token => '+ JSON.stringify(err))
    //         self.spinner.hide()
    //       }
    //   }

    preventSpace(event) {
        if ((event.charCode == 32 || event.charCode == 64) && !event.target.value) {
            event.preventDefault();
        } else {
            // console.log(event)
        }
        // console.log('event charCode check', event.charCode)
    }

    /** to check characters start */
    toCheckSpaceChar(evt) {
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode == 32) || (charCode > 64 && charCode < 91) || (charCode > 96 && charCode < 123)) {
            evt.preventDefault()
        } else {
            return true;
        }
    }
    companyLogo: any
    companylogoImage() {
        this.getApi('admin/logoListing', 1).subscribe(response => {
            if (response.responseCode == 200) {
                this.companyLogo = response.result[0].image
            } else {
                this.companyLogo = "assets/images/logo.png"
            }
        })
    }
    /** to check characters end  */

    returnResponse() {
        let res = {
            "responseCode": 200,
            "responseMessage": "Data found.",
            "result": {
                "_id": "61cc5a1387d59c9c0b724137",
                "startDate": "2021-12-01T00:00:00.000Z",
                "endDate": "2021-12-02T00:00:00.000Z",
                "competitionId": {
                    "status": "published",
                    "compStatus": "ACTIVE",
                    "allowComment": true,
                    "clubRegistration": true,
                    "allowPublicToFollow": true,
                    "registrationForm": true,
                    "published": true,
                    "playerFollowStatus": [
                        {
                            "playerId": "61c6f1c4482d07612558cf9d",
                            "followStatus": "APPROVED"
                        },
                        {
                            "playerId": "61c705f6edcaf67236c0eede",
                            "followStatus": "APPROVED"
                        },
                        {
                            "playerId": "61c9d181563a38f4778505c8",
                            "followStatus": "APPROVED"
                        },
                        {
                            "playerId": "61c2fec079527c4d932981e2",
                            "followStatus": "APPROVED"
                        },
                        {
                            "playerId": "61cda4c3b0f079d1520e82f7",
                            "followStatus": "APPROVED"
                        }
                    ],
                    "_id": "61c2e9cc453a61343b34bf30",
                    "competitionName": "Rajats Warrior",
                    "venue": "DD",
                    "division": "D1",
                    "period": "P1",
                    "sports": "Cricket",
                    "sportType": "team",
                    "club": "v",
                    "organizer": "61c2d943453a61343b34bf2a",
                    "prize": [],
                    "file": [],
                    "createdAt": "2021-12-22T09:03:08.230Z",
                    "updatedAt": "2021-12-31T12:43:32.109Z",
                    "__v": 0,
                    "endDate": "2021-12-29",
                    "imageURL": "https://res.cloudinary.com/singhanurag400/image/upload/v1640592644/jpnk7eg004druxwrsaet.png",
                    "startDate": "2021-12-27"
                },
                "organizerId": "61c2d943453a61343b34bf2a",
                "roundName": 1,
                "groupId": "61cc595587d59c9c0b724132",

                "games": [
                    {
                        "team1": null,
                        "team2": null,
                        "result1": 4,
                        "result2": 2,
                        "matchTime": "1638297000000",
                        "teamName1": "moin",
                        "teamName2": "raja",
                        "place": "",
                        "win": "moin",
                        "loss": "raja",
                        "_id": "61cc5a1387d59c9c0b724138",
                        "refereeId": null
                    },
                    {
                        "team1": "61c98b2b2f6f11bc4d82709f",
                        "team2": "61c6f067482d07612558cf9b",
                        "result1": null,
                        "result2": null,
                        "matchTime": "",
                        "teamName1": "sushmita",
                        "teamName2": "vishnu",
                        "place": "",
                        "win": "",
                        "loss": "",
                        "_id": "61cc5a1387d59c9c0b724139"
                    }
                ],
                "createdAt": "2021-12-29T12:52:35.591Z",
                "updatedAt": "2021-12-29T12:53:38.324Z",
                "__v": 0
            }
        }
        return res
    }


}



// WEBPACK FOOTER //
// /Users/tanveer/Documents/sportsYala_New/sportswebmobplatform-18023153-angular4/src/app/providers/mainService.service.ts